import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Actions, StoreState } from '../types';

type Callback = Record<string, true | undefined>

export default function callback(state: Callback = {}, action: Actions): Callback {
  switch (action.type) {
    case getType(actions.setCallback):
      const { ext, callback } = action.payload

      if (callback) {
        return {
          ...state,
          [ext]: true,
        }
      } else {
        const { [ext]: _, ...rest } = state
        return rest
      }

      default:
        return state
  }
}

function getRoot(s: StoreState) { return s.callback }

export function selectHaveCallback(state: StoreState, ext: string) {
  return Boolean(getRoot(state)[ext])
}
